import React, { useState } from 'react';
import { toast } from 'react-toastify';
import axios from 'axios';

import './style.css';

import vimg from '../../images/lhcf/lhcf-5.jpeg';

const Volunteer = () => {
  const [payload, setPayload] = useState({
    firstName: '',
    lastName: '',
    country: '',
    city: '',
    phoneNumber: '',
    email: '',
    motivation: '',
  });
  const [buttonDisabled, setButtonDisabled] = useState(false);

  const baseUrl = process.env.REACT_APP_BASE_URL;

  const handleInputChange = (e) => {
    const key = e.target.name;
    const value = e.target.value;

    setPayload({ ...payload, [key]: value });
  };

  const submitHandler = (e) => {
    e.preventDefault();

    setButtonDisabled(true);

    axios
      .post(`${baseUrl}/volunteer`, payload)
      .then((res) => {
        toast.success(
          'Submitted the volunteer request. We will get back to you soon!'
        );

        setPayload({
          firstName: '',
          lastName: '',
          country: '',
          city: '',
          phoneNumber: '',
          email: '',
          motivation: '',
        });

        setButtonDisabled(false);
      })
      .catch((err) => {
        if (err.response.status === 400) {
          toast.error(err.response.data.message);
        } else {
          toast.error(
            'Could not submit the volunteer request. Try again or check back later'
          );
        }

        setButtonDisabled(false);
      });
  };

  return (
    <div className='volunteer-area'>
      <div className='volunteer-wrap'>
        <div className='container'>
          <div className='row'>
            <div className='col-12'>
              <div className='volunteer-item'>
                <div className='volunteer-img-wrap'>
                  <div className='volunter-img'>
                    <img src={vimg} alt='' />
                  </div>
                </div>
              </div>
              <div className='volunteer-contact'>
                <div className='volunteer-contact-form'>
                  <h2>Become a Volunteer</h2>
                  <form
                    onSubmit={submitHandler}
                    className='contact-validation-active'
                    id='contact-form'
                  >
                    <div className='row'>
                      <div className='col-lg-6 col-md-6 col-sm-6 col-12 form-group'>
                        <input
                          type='text'
                          className='form-control'
                          name='firstName'
                          id='firstname'
                          placeholder='First Name'
                          required
                          value={payload.firstName}
                          onChange={handleInputChange}
                        />
                      </div>
                      <div className='col-lg-6 col-md-6 col-sm-6 col-12 form-group'>
                        <input
                          type='text'
                          className='form-control'
                          name='lastName'
                          id='lastname'
                          placeholder='Last Name'
                          required
                          value={payload.lastName}
                          onChange={handleInputChange}
                        />
                      </div>
                      <div className='col-lg-6 col-md-6 col-sm-6 col-12 form-group'>
                        <input
                          type='text'
                          className='form-control'
                          name='country'
                          id='country'
                          placeholder='Country'
                          required
                          value={payload.country}
                          onChange={handleInputChange}
                        />
                      </div>

                      <div className='col-lg-6 col-md-6 col-sm-6 col-12 form-group'>
                        <input
                          type='text'
                          className='form-control'
                          name='city'
                          id='city'
                          placeholder='City'
                          required
                          value={payload.city}
                          onChange={handleInputChange}
                        />
                      </div>

                      <div className='col-lg-6 col-md-6 col-sm-6 col-12 form-group'>
                        <input
                          type='text'
                          className='form-control'
                          name='phoneNumber'
                          id='phone'
                          placeholder='Phone Number'
                          required
                          value={payload.phoneNumber}
                          onChange={handleInputChange}
                        />
                      </div>

                      <div className='col-lg-6 col-md-6 col-sm-6 col-12 form-group clearfix'>
                        <input
                          type='email'
                          className='form-control'
                          name='email'
                          id='email'
                          placeholder='Email'
                          required
                          value={payload.email}
                          onChange={handleInputChange}
                        />
                      </div>

                      <div className='col-lg-12 col-12 form-group'>
                        <textarea
                          className='form-control'
                          name='motivation'
                          id='motivation'
                          placeholder='Motivation...'
                          required
                          value={payload.motivation}
                          onChange={handleInputChange}
                        ></textarea>
                      </div>
                      <div className='submit-area col-lg-12 col-12'>
                        <button
                          disabled={buttonDisabled}
                          type='submit'
                          className='theme-btn submit-btn'
                        >
                          Submit Request
                        </button>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Volunteer;
